
import React, { Component,useState,useEffect,useContext } from 'react';
import { Link, useHistory } from "react-router-dom";
import {getDate} from "../../Utils/Dates";
import styled from "styled-components";
import Header from "../../Components/Lista/HeaderCheckin";
import AppContext from '../../Context/AppContext';
import "./Loading.css";
import Alert from '../../Components/Alert';

const InputContainer=styled.div`
display:grid;
justify-content: center;
justify-items: center;
justify-self: center;
`;

const InputText=styled.input`
text-align:center;
margin-top:7.5px;
border: 1px solid #bbbbbd;
font-size:18px;
width:297px;
height:55px;
border-radius:6px;
outline:none;

@media screen and (max-width:428px)
{
    width:100%;
}`;

const StyledLink=styled(Link)`
text-decoration:none;`;

const Button=styled.button`
display:grid;
justify-content: center;
justify-items: center;
justify-self: center;
margin: 15px auto;
font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
font-size:16px;
font-weight:700;
border-radius:6px;
border:none;
height: 54px;
width: 300px;
margin-bottom: 0;
padding:1em;
color:white;
outline:none;
background-color: rgb(0, 136, 255);
cursor:pointer;

@media screen and (max-width:428px)
{
  width:100%;
  border-radius:0px;
  position:fixed;
  bottom:0;
}`;

const TextoCargando=styled.p`
text-align: center;
margin: 10px;`;

const Nota=()=>
{
    const {Customer}=useContext(AppContext);
    const History=useHistory();
    const [Note, setNote] = useState("");
    const [Error, setError] = useState("")
    const [Loading,setLoading] = useState(false);

    useEffect(() => 
    {
       const {phone}=Customer;
       if(phone==="")
       {
           History.replace("/lista");
       }
    }, []);

    const Submit=async ()=>
    {
        
        setLoading(true);
        const id=Date.now();
        let phone=undefined;

        if(Customer.phone.startsWith("15"))
        {
            phone=`54911${Customer.phone.substring(2)}`
        }
        else
        {       
            phone=`549${Customer.phone}`;
        }

        const Cliente={name:Customer.name,dinersCount:Customer.count,phone,note:Note,date:getDate(),id,status:"annotated"}

        
        try 
        {      
            await window.axios.post("/customer/?Whatsapp=true",Cliente)      
            Customer.docID=id;
            Customer.note=Note;

            setError("")
            setLoading(false);
    
            History.push("/lista/confirmado");
        }
        catch (error) 
        {
            if(error.response)
            {
                setError(error.response.data.msg)
            }
            setLoading(false);
        }

    }

    const ContainerLoading=()=>
    {
        if(Loading)
        {

            return  <div class="load"></div>
            
        }
        else
        {
            return <Button onClick={Submit}>{Note.length>0 ? "Confirmar" : "Confirmar sin notas"} </Button>
        }
    }

    return  <>
    <Header/>
    <div style={{margin:"20px 0 0"}}>
        <InputContainer>
            <h2 style={{justifySelf:"start",margin:"7.5px 0 0 0"}}>Nota</h2>
            <InputText autoFocus value={Note} onChange={e => setNote(e.target.value)}/>
            <Alert type={"error"} mensaje={Error} close={() => setError("")}/>
        </InputContainer>
        <ContainerLoading/>
    </div>
 </>
}

export default Nota;